module.exports = __webpack_public_path__ + "static/img/img_chuandai_shebei_02.fed518ab.jpg";